import React from 'react';
import useTranslation from 'next-translate/useTranslation';
import { Box } from '@mantine/core';

import { Text } from '~/domains/design-system/Text';
import { Button } from '~/domains/design-system/Button';

import useStyles from './ContestNotificationWidget.styles';

function ContestNotificationWidgetFooter({ onViewAllClick }: { onViewAllClick?: (e: React.MouseEvent) => void }) {
  const { classes } = useStyles();
  const { t } = useTranslation('contest');

  if(!onViewAllClick) {
    return null;
  }

  return (
      <Box className={classes.footer}>
        <Button
          variant="primary-text"
          mode="linkButton"
          onClick={onViewAllClick}
        >
          <Text className={classes.viewAllButtonFooter} fw={600} variant="label-medium">
            {t('common.contestNotificationWidget.viewAll')}
          </Text>
        </Button>
      </Box>
    )
}

export default ContestNotificationWidgetFooter
